import * as React from 'react'
import styled from '@theme/styled-components'
import { BsSearch } from 'react-icons/bs'
import Theme from '@theme/Theme'
import Loader from 'react-loader-spinner'

interface Props {
  placeholder: string
  text: string
  setText: (text: string) => void
  onSend?: () => void
  loading?: boolean
}

const Searchbar = ({ placeholder, text, setText, onSend, loading = false }: Props) => {
  return (
    <Container comment={!!onSend}>
      <InputText
        comment={!!onSend}
        value={text}
        onChange={(evt) => setText(evt.target.value)}
        placeholder={placeholder}
        onKeyPress={(event) => {
          if (event.key === 'Enter' && !!onSend) {
            onSend()
          }
        }}
        disabled={loading}
      />
      {text && !loading && (
        <CrossContainer onClick={() => setText('')}>
          <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
            fill={Theme.colors.filterPrimarycolor}>
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
          </svg>
        </CrossContainer>
      )}
      {loading ? (
        <Loader type="ThreeDots" color={Theme.colors.classicButtonLoader} height={10} />
      ) : !onSend ? (
        <BsSearch size={20} color={Theme.colors.iconColor} />
      ) : (
        <SendContainer onClick={onSend}>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="24" height="24" rx="12" fill="#0053A1" stroke="#0053A1" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.1752 6.24879L6.59448 9.7741C5.74029 10.0604 5.1575 10.8517 5.13734 11.7524C5.11717 12.6532 5.66395 13.4701 6.50446 13.795L10.4198 15.2921C10.6074 15.3689 10.7563 15.5178 10.833 15.7054L12.3302 19.6207C12.5897 20.2964 13.1735 20.7951 13.8815 20.9457C14.5894 21.0964 15.3254 20.8786 15.8373 20.367C16.0708 20.1288 16.2481 19.8413 16.3561 19.5257L19.8814 8.94496C20.1349 8.178 19.9343 7.33352 19.363 6.76219C18.7917 6.19087 17.9472 5.99029 17.1802 6.24375L17.1752 6.24879ZM18.4145 8.58664L14.9808 18.8876C14.8848 19.161 14.629 19.3459 14.3394 19.3514C14.0497 19.3568 13.7871 19.1817 13.6809 18.9122L12.2192 15.1057C12.1992 15.0554 12.1762 15.0062 12.1505 14.9586L15.5302 11.5788C15.8011 11.3079 15.8011 10.8687 15.5302 10.5978C15.2593 10.3269 14.8201 10.3269 14.5492 10.5978L11.1694 13.9775C11.1218 13.9518 11.0726 13.9289 11.0223 13.9089L7.21584 12.4471C6.94631 12.3409 6.77119 12.0783 6.77666 11.7887C6.78212 11.499 6.96703 11.2432 7.24037 11.1472L17.5414 7.71351C17.7891 7.63362 18.0607 7.69914 18.2448 7.88321C18.4289 8.06727 18.4944 8.33889 18.4145 8.58664Z"
              fill={Theme.colors.secondary_text}
            />
          </svg>
        </SendContainer>
      )}
    </Container>
  )
}

export default Searchbar

const Container = styled('div')<{ comment?: boolean }>`
  background: ${(props) =>
    !!props.comment ? props.theme.colors.filterBackgroundColor : props.theme.colors.searchbarBackground};
  border: ${(props) => (!!props.comment ? '0px' : '1px')} solid ${(props) => props.theme.colors.searchbarBorder};
  box-sizing: border-box;
  backdrop-filter: blur(5px);
  border-radius: 7px;
  height: 50px;
  padding: 5px 10px;
  display: flex;
  ${(props) => !!props.comment && 'flex: 1;'}
  align-items: center;
`
const InputText = styled('input')<{ comment?: boolean }>`
  outline: none;
  border: none;
  padding: 5px;
  display: flex;
  flex: 1;
  margin-right: 5px;
  background: ${(props) =>
    !!props.comment ? props.theme.colors.filterBackgroundColor : props.theme.colors.searchbarBackground};
  ${(props) => props.theme.fonts.label};
  font-size: 15px;
`
const CrossContainer = styled('div')`
  display: flex;
  height: 50px;
  width: 20px;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
  cursor: pointer;
`
const SendContainer = styled('div')`
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
`
